import {isNotUndefined} from '@logistics-frontend/utils'
import {PreOrderRetrieveResponse} from '@yandex-delivery/api/repo/dcaa'

import {SelectedRequirementsMap} from 'src/shared/types'

export const toSelectedRequirementsMap = (preOrderRetrieve: PreOrderRetrieveResponse): SelectedRequirementsMap => {
  const requirements: SelectedRequirementsMap = {
    insurance: true,
  }

  const offerRequirements = preOrderRetrieve.claim.offer_requirements

  if (offerRequirements?.cargo_type) {
    requirements.cargo_type = offerRequirements.cargo_type
  }

  if (isNotUndefined(offerRequirements?.cargo_loaders)) {
    requirements.cargo_loaders = offerRequirements.cargo_loaders
  }

  if (offerRequirements?.skip_door_to_door) {
    requirements.door_to_door = Boolean(preOrderRetrieve.claim.offer_requirements?.skip_door_to_door)
  }

  return requirements
}
